import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material";
import { AppButton } from "components/common/buttons";

const initialForm = {
  Name: "",
  DocumentCategory: "",
  Note: "",
};

const AddDocumentTypeDialog = ({
  open,
  onClose,
  onSubmit,
  documentCategoryOptions = [],
  defaultDocumentCategory = "",
  submitting = false,
}) => {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      setForm({
        ...initialForm,
        DocumentCategory: defaultDocumentCategory || "",
      });
      setErrors({});
    }
  }, [defaultDocumentCategory, open]);

  const handleChange = (field) => (event) => {
    setForm((prev) => ({ ...prev, [field]: event.target.value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleSubmit = async () => {
    const nextErrors = {};

    if (!form.Name.trim()) {
      nextErrors.Name = "Vui lòng nhập tên loại tài liệu";
    }

    if (!form.DocumentCategory.trim()) {
      nextErrors.DocumentCategory = "Vui lòng chọn nhóm tài liệu";
    }

    setErrors(nextErrors);
    if (Object.keys(nextErrors).length > 0) return;

    await onSubmit({
      Name: form.Name.trim(),
      DocumentCategory: form.DocumentCategory.trim(),
      Note: form.Note.trim() || null,
    });
  };

  return (
    <Dialog open={open} onClose={submitting ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 600, fontFamily: "Inter, sans-serif" }}>
        Thêm mới loại tài liệu
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} sx={{ pt: 0.5 }}>
          <TextField
            label="Tên loại tài liệu"
            value={form.Name}
            onChange={handleChange("Name")}
            error={Boolean(errors.Name)}
            helperText={errors.Name}
            fullWidth
            required
            size="small"
            autoFocus
          />

          <Autocomplete
            options={documentCategoryOptions}
            value={
              documentCategoryOptions.includes(form.DocumentCategory)
                ? form.DocumentCategory
                : null
            }
            onChange={(event, value) => {
              setForm((prev) => ({
                ...prev,
                DocumentCategory: value || "",
              }));
              setErrors((prev) => ({ ...prev, DocumentCategory: "" }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Nhóm tài liệu"
                error={Boolean(errors.DocumentCategory)}
                helperText={errors.DocumentCategory}
                required
                size="small"
              />
            )}
          />

          <TextField
            label="Ghi chú"
            value={form.Note}
            onChange={handleChange("Note")}
            fullWidth
            multiline
            minRows={3}
            size="small"
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <AppButton variant="outlined" onClick={onClose} disabled={submitting}>
          Hủy
        </AppButton>
        <AppButton variant="contained" onClick={handleSubmit} disabled={submitting} disableElevation>
          Lưu
        </AppButton>
      </DialogActions>
    </Dialog>
  );
};

export default AddDocumentTypeDialog;
